import { Button } from "react-bootstrap";
import parse from "html-react-parser";
import { NoRecordFound } from "components/Common/Common";
import formIcn from "Assets/images/formIcn.svg";
import LoadingIndicator from "components/shared/LoadingIndicator";

const ViewAttachments = ({ title, attachments, handleViewPdf, isLoading = false }) => {
  return (
    <div className="report-attachments my-3">
      <h5 className="m-0 fw-bold pb-2">{title}</h5>
      {attachments?.length > 0 ? (
        <div
          className={`tableResponsive table-responsive pb-0`}
        >
          <table className={`table mb-0`}>
            <thead>
              <tr>
                <th className="m-0 themeBlue fw-bold py-2">Name</th>
                <th className="m-0 themeBlue fw-bold py-2"></th>
              </tr>
            </thead>
            <tbody>

              {
                attachments?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="">
                        <div className="d-flex align-items-center gap-10">
                          <span className="icn flex-shrink-0">
                            <img
                              src={formIcn}
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                          <p className="m-0" role="button" onClick={() => handleViewPdf(item?.attachment_key)}>{parse(item?.attachment_name) || "--"}</p>
                        </div>
                      </td>
                      {/* <td className="">{convertToMomentDate(item?.createdAt)}</td> */}
                      <td className="">
                        <div className="d-flex align-items-center gap-10">
                          {
                            <Button
                              style={{ minWidth: "unset" }}
                              className="d-flex align-items-center justify-content-center commonBtn h-auto"
                              disabled={isLoading}
                              onClick={() => handleViewPdf(item?.attachment_key)}
                            >
                              <span className="icn me-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="11"
                                  viewBox="0 0 16 11"
                                  fill="none"
                                >
                                  <path
                                    d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>
                              {isLoading ? <LoadingIndicator/> :  "View"}
                            </Button>
                          }
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      ) : (
        <NoRecordFound />
      )}
    </div>
  )
}

export default ViewAttachments;